import Swiper from 'swiper';

/* eslint-disable import/no-unresolved */
import 'swiper/css';
/* eslint-enable import/no-unresolved */

import { breakpoints } from '../helpers/constants';
import { getElements } from '../helpers/functions';
const cardSlider = $el => {
  const config = {
    spaceBetween: 10,
    slidesPerView: 1,
    breakpoints: {
      [breakpoints.sm]: {
        slidesPerView: 1.5,
        spaceBetween: 10
      },
      [breakpoints.md]: {
        slidesPerView: 2.5
      }
    }
  };
  let cardSwiper = null;
  window.addEventListener('windowResize', e => {
    const tablet = e.detail.windowWidth < breakpoints.lg;
    if (tablet && cardSwiper === null) {
      cardSwiper = new Swiper($el, config);
    } else if (!tablet && cardSwiper !== null) {
      cardSwiper.destroy();
      cardSwiper = null;
    }
  });
};
export default () => {
  getElements('.ce-card_group--slider').forEach($slide => cardSlider($slide));
};